<div class="container">
  <div class="col-sm-12">
    <div class="text-center">
      {{ error }}
    </div>
  </div>
</div>
